/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

function Bannerswiper() {
    var swiper = new Swiper(".mySwiper", {
        autoplay:true,
      speed:1000,
      loop:true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                var pageNumber = ("0" + (index + 1)).slice(-2); // Add leading zeros
                return '<span class="' + className + '">' + pageNumber + '<br/><span class="bullet"></span></span>';
            },
        },
    });
}

Bannerswiper();


// document.addEventListener("DOMContentLoaded", function() {
//   if (window.location.pathname.includes("checkout")) {
//     console.log("On checkout page");
//     const targetElement = document.querySelector('.RsSB7');
//     if (targetElement) {
//       console.log("Target element found:", targetElement);
//       const newImageElement = document.createElement("img");
//       newImageElement.src = "//mihikoli.com/cdn/shop/files/mi-hi-koli-header-logo.svg?v=1713789007&width=190";
//       newImageElement.alt = "Mi Hi Koli";
//       newImageElement.width = 190;
//       newImageElement.height = 45;
//       newImageElement.loading = "eager";
//       newImageElement.classList.add("logo__img", "logo__img--color");
//       newImageElement.srcset = `
//         //mihikoli.com/cdn/shop/files/mi-hi-koli-header-logo.svg?v=1713789007&width=380 2x,
//         //mihikoli.com/cdn/shop/files/mi-hi-koli-header-logo.svg?v=1713789007&width=570 3x,
//         //mihikoli.com/cdn/shop/files/mi-hi-koli-header-logo.svg?v=1713789007&width=190
//       `;
//       targetElement.parentNode.replaceChild(newImageElement, targetElement);
//       console.log("Target element replaced with new image element");
//     } else {
//       console.log("Target element not found");
//     }
//   }
// });


function removePswpOpenClass() {
    var element = document.querySelector('.pswp.pswp--supports-fs.pswp--open.pswp--animate_opacity.pswp--notouch.pswp--css_animation.pswp--svg.pswp--zoom-allowed.pswp--visible.pswp--animated-in');
    
    if (element) {
        element.classList.remove('pswp--open');
        // console.log("Removed 'pswp--open' class from element.");
    } else {
        // console.log("Element not found or already does not have 'pswp--open' class.");
    }
    
    document.body.style.overflow = '';
    console.log("Removed 'overflow: hidden' from body.");
}



// gallery js shubham

 document.addEventListener('DOMContentLoaded', function() {
    const appGallery = GLightbox({
      selector: '.glightbox[data-gallery="portfolio-gallery-app"]',
    });

    const productGallery = GLightbox({
      selector: '.glightbox[data-gallery="portfolio-gallery-product"]',
    });

    const brandingGallery = GLightbox({
      selector: '.glightbox[data-gallery="portfolio-gallery-branding"]',
    });

    const bookGallery = GLightbox({
      selector: '.glightbox[data-gallery="portfolio-gallery-book"]',
    });

    // Your other code here
    new PureCounter();

    // Init isotope layout and filters
    document.querySelectorAll(".isotope-layout").forEach(function (isotopeItem) {
        let layout = isotopeItem.getAttribute("data-layout") ?? "masonry";
        let filter = isotopeItem.getAttribute("data-default-filter") ?? "*";
        let sort = isotopeItem.getAttribute("data-sort") ?? "original-order";

        let initIsotope;
        imagesLoaded(isotopeItem.querySelector(".isotope-container"), function () {
            initIsotope = new Isotope(
                isotopeItem.querySelector(".isotope-container"),
                {
                    itemSelector: ".isotope-item",
                    layoutMode: layout,
                    filter: filter,
                    sortBy: sort,
                }
            );
        });

        isotopeItem.querySelectorAll(".isotope-filters li").forEach(function (filters) {
            filters.addEventListener("click", function () {
                isotopeItem.querySelector(".isotope-filters .filter-active").classList.remove("filter-active");
                this.classList.add("filter-active");
                initIsotope.arrange({
                    filter: this.getAttribute("data-filter"),
                });
                if (typeof aosInit === "function") {
                    aosInit();
                }
            }, false);
        });
    });
});


   


